import React, { useState } from 'react';
import { isSubscriptionPaused, isSubscriptionPauseScheduled } from '../../utils';
import { CustomerSubscription } from '../../types';
import moment from 'moment/moment';
import { Button } from 'react-bootstrap';
import { UnpauseConfirmationModal } from './UnpauseConfirmationModal';

const formatMonthAndDay = (date: Date) => moment(date).format('MMMM D');

export const UnpauseSubscriptionBanner = (props: { activeSubscription: CustomerSubscription }) => {
  const { activeSubscription } = props;
  const now = new Date();
  const paused = isSubscriptionPaused(activeSubscription, now);
  const pauseScheduled = isSubscriptionPauseScheduled(activeSubscription, now);
  const [unpauseModalKey, setUnpauseModalKey] = useState<number | null>(null);

  if (!paused && !pauseScheduled) return null;
  if (!activeSubscription.resumeAt) return null;
  if (activeSubscription.cancelAt) return null;
  return (
    <div className="billing__unpause-plan-wrapper">
      <div className="billing__unpause-plan-container">
        <div className="growegy-font16--weight500 growegy-font-em">
          {pauseScheduled && activeSubscription.pauseAt
            ? `Your plan will pause on ${formatMonthAndDay(activeSubscription.pauseAt)}.`
            : 'Your plan is currently paused.'}
        </div>
        <div className="release-prompt__content-container">
          <div>
            <ul>
              <li>While your plan is paused no new invoices are issued.</li>
              <li>
                {`The plan will automatically resume on ${formatMonthAndDay(
                  activeSubscription.resumeAt
                )}.`}
              </li>
              <li>
                <span>If you would like you can resume your plan earlier.</span>
              </li>
            </ul>
            <Button
              variant="primary"
              className="button-apply"
              onClick={() => setUnpauseModalKey(new Date().valueOf())}
            >
              Resume now
            </Button>
          </div>
        </div>
        {unpauseModalKey && <UnpauseConfirmationModal key={unpauseModalKey} />}
      </div>
    </div>
  );
};
